import { useEffect, useState } from "react";
import { PaperPlaneRight, Gear, ChatText } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export default function NotesPanel({ relatedType, relatedId }) {
  const [notes, setNotes] = useState([]);
  const [text, setText] = useState("");

  const load = async () => {
    const { data } = await api.get("/notes", { params: { related_type: relatedType, related_id: relatedId } });
    setNotes(data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [relatedId]);

  const add = async () => {
    if (!text.trim()) return;
    await api.post("/notes", { related_type: relatedType, related_id: relatedId, text });
    setText("");
    load();
  };

  return (
    <div>
      <div className="flex gap-2 mb-5">
        <Textarea data-testid="note-input" value={text} onChange={(e) => setText(e.target.value)} placeholder="Add a note to the activity log…" className="min-h-[44px]" />
        <Button data-testid="note-submit" onClick={add} className="self-end"><PaperPlaneRight size={16} /></Button>
      </div>
      <div className="relative pl-6">
        <div className="absolute left-2 top-1 bottom-1 w-px bg-border" />
        <div className="space-y-4">
          {notes.map((n) => (
            <div key={n.id} data-testid={`activity-${n.id}`} className="relative">
              <div className={`absolute -left-[18px] top-1 h-3 w-3 rounded-full border-2 border-background ${n.type === "note" ? "bg-gold" : "bg-primary"}`} />
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                {n.type === "note" ? <ChatText size={13} /> : <Gear size={13} />}
                <span className="font-medium text-foreground">{n.author_name}</span>
                <span>· {n.created_at?.slice(0, 16).replace("T", " ")}</span>
              </div>
              <div className="text-sm mt-1">{n.text}</div>
            </div>
          ))}
          {notes.length === 0 && <div className="text-sm text-muted-foreground">No activity yet.</div>}
        </div>
      </div>
    </div>
  );
}
